import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { RootState } from '../../stores/store';
import { PopularSportsAndCategories } from './types';

export const getPopularSportsAndCategories = () => false;
export const POPULAR_SPORTS_AND_CATEGORIES = [];

const dynamicBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, WebApi, extraOptions) => {
  const client = (WebApi.getState() as RootState).config.client;
  const baseUrl = `${
    (WebApi.getState() as RootState).config.cmsUrl
  }/api/client/${client}`;
  const rawBaseQuery = fetchBaseQuery({ baseUrl });
  return rawBaseQuery(args, WebApi, extraOptions);
};

export type GetSportCategoriesResult =
  PopularSportsAndCategories['popularSports'];

// Define a service using a base URL and expected endpoints
export const cmsApi = createApi({
  reducerPath: 'cmsApi',
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getSportCategories: builder.query<GetSportCategoriesResult, void>({
      query: () => `/sports`,
      transformResponse: (response: PopularSportsAndCategories) => {
        return response.popularSports;
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSportCategoriesQuery } = cmsApi;
